import { ClientEntity } from "@jackfruit/common"
import { createEntitySlice } from "../createEntitySlice"

export const { slice: clients, selectors: clientsSelector } = createEntitySlice<
  ClientEntity
>("clients")
